import React from "react";

const DownloadIcon = () => {
  return (
    <svg
      width="23"
      height="22"
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6195 12.832L11.0891 13.3624L11.6195 13.8927L12.1498 13.3624L11.6195 12.832ZM12.3695 4.58203C12.3695 4.16782 12.0337 3.83203 11.6195 3.83203C11.2053 3.83203 10.8695 4.16782 10.8695 4.58203L12.3695 4.58203ZM6.5058 8.77903L11.0891 13.3624L12.1498 12.3017L7.56646 7.71837L6.5058 8.77903ZM12.1498 13.3624L16.7331 8.77903L15.6725 7.71837L11.0891 12.3017L12.1498 13.3624ZM12.3695 12.832L12.3695 4.58203L10.8695 4.58203L10.8695 12.832L12.3695 12.832Z"
        fill="#8b58f1"
      />
      <path
        d="M5.20215 14.668L5.20215 15.5846C5.20215 16.5972 6.02296 17.418 7.03548 17.418L16.2021 17.418C17.2147 17.418 18.0355 16.5972 18.0355 15.5846V14.668"
        stroke="#8b58f1"
        stroke-width="1.5"
      />
    </svg>
  );
};

export default DownloadIcon;
